import { render, staticRenderFns } from "./EventInfoCards.vue?vue&type=template&id=629cb2a4&scoped=true&"
import script from "./EventInfoCards.vue?vue&type=script&lang=js&"
export * from "./EventInfoCards.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoCards.vue?vue&type=style&index=0&id=629cb2a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629cb2a4",
  null
  
)

export default component.exports